export default {
	// api请求地址
	baseUrl: 'https://www.cmingming.top',
	// 图片域名
	imgDomain: 'https://www.cmingming.top',
	// 腾讯地图key
	mpKey: '',
	// 客服
	webSocket: 'wss://www.cmingming.top/wss',
	// api安全
	apiSecurity: "0",
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500,
	// 公钥
	publicKey: ``,
}